/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespFeaturedModule_componentModule = {
    readonly primaryItem: {
        readonly cta: string | null;
        readonly imageUrl: string | null;
        readonly imageHeight: string | null;
        readonly imageWidth: string | null;
        readonly mobileImageHeight?: string | null;
        readonly mobileImageWidth?: string | null;
        readonly mobileImageUrl?: string | null;
        readonly title: string | null;
        readonly linkData: {
            readonly path: string | null;
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null;
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly cta: string | null;
        readonly imageUrl: string | null;
        readonly title: string | null;
        readonly linkData: {
            readonly path: string | null;
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null> | null;
    readonly " $refType": "HpRespFeaturedModule_componentModule";
};
export type HpRespFeaturedModule_componentModule$data = HpRespFeaturedModule_componentModule;
export type HpRespFeaturedModule_componentModule$key = {
    readonly " $data"?: HpRespFeaturedModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespFeaturedModule_componentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cta",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "imageUrl",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SeoLink_linkData",
      "args": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "HpRespFeaturedModule_componentModule",
  "type": "FeaturedModule",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "primaryItem",
      "storageKey": null,
      "args": null,
      "concreteType": "FeaturedItem",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageHeight",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageWidth",
          "args": null,
          "storageKey": null
        },
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "isMobile",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageHeight",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageWidth",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "mobileImageUrl",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "FeaturedItem",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cmsId",
          "args": null,
          "storageKey": null
        },
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/)
      ]
    }
  ]
};
})();
(node as any).hash = 'e73043572a7739e45db8a7840c89603c';
export default node;
